// Empty Cart Featured Product - Add to Cart Handler
// Using event delegation for better performance and reliability

async function handleAddToCart(button) {
  const variantId = button.getAttribute('data-variant-id');
  
  if (!variantId) {
    console.error('No variant ID found');
    return;
  }
  
  // Disable button and show loading spinner
  button.disabled = true;
  button.classList.add('loading');
  
  try {
    // Get the section ID from the cart drawer component
    const cartItemsComponent = document.querySelector('cart-items-component');
    const sectionId = cartItemsComponent?.dataset.sectionId;
    
    // Add item to cart using Shopify Cart API, requesting the updated section
    const body = {
      items: [{
        id: parseInt(variantId),
        quantity: 1
      }]
    };
    
    if (sectionId) {
      body.sections = sectionId;
      body.sections_url = window.location.pathname;
    }

    const response = await fetch(window.Shopify.routes.root + 'cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(body)
    });
    
    if (!response.ok) {
      const error = await response.json();
      throw new Error(error.description || 'Failed to add to cart');
    }
    
    const cartData = await response.json();
    
    // Dispatch CartAddEvent with correct event name 'cart:update'
    // This matches ThemeEvents.cartUpdate in events.js
    const cartAddEvent = new CustomEvent('cart:update', {
      bubbles: true,
      detail: {
        resource: cartData,
        sourceId: variantId,
        data: {
          source: 'empty-cart-featured-product',
          itemCount: 1,
          variantId: variantId,
          didError: false,
          sections: cartData.sections // Include the returned sections
        }
      }
    });
    
    document.dispatchEvent(cartAddEvent);
    
    // Show success checkmark
    button.classList.remove('loading');
    button.classList.add('success');
    
    // The cart will refresh and show the items, removing the empty cart state
    
  } catch (error) {
    console.error('Error adding to cart:', error);
    button.classList.remove('loading');
    button.disabled = false;
  }
}

// Event delegation - single listener for all buttons
document.addEventListener('click', function(e) {
  const button = e.target.closest('.empty-cart__add-button');
  if (button) {
    e.preventDefault();
    handleAddToCart(button);
  }
});
